/** @ignore */
export default function (notificationsConfigProvider) {
	'ngInject';
	// see https://github.com/alexbeletsky/ng-notifications-bar
	notificationsConfigProvider.setAutoHide(true);
	notificationsConfigProvider.setHideDelay(5000);
	notificationsConfigProvider.setAcceptHTML(true);
}
